export default {
  map_areas: {
    'france.chambord.chateau': {
      'enceintebasse.0.accueil': 'Accueil - Billetterie',
      'courchateau.0.sud': 'Cour du château',
      'donjon.0.vestibulesud': 'Bras de croix sud',
      'donjon.0.salledeschasses': 'Salle des chasses',
      'donjon.0.vestibuleest': 'Bras de croix est',
      'donjon.0.salledesillustres': 'Salle des Illustres',
      'donjon.0.vestibulenord': 'Bras de croix nord',
      'donjon.0.salledesbourbons': 'Salle des Bourbons',
      'donjon.0.vestibuleouest': 'Bras de croix ouest',
      'donojon.0.salleaudiovisuelle': 'Salle audiovisuelle',
      'enceintebasse.0.cafeorleans': "Café d'Orléans",
      'enceintebasse.0.salledescarrosses': 'Salle des carrosses',
      'enceintebasse.0.fosselatrine': 'Fosse des latrines',
      'enceintebasse.0.depotlapidaire': 'Dépôt lapidaire',
      'donjon.0.cuisinepolignac': 'Cuisines du XVIIIe siècle',
      'enceintebasse.0.avantboutique': 'Librairie - boutique - Sortie',
      'enceintebasse.0.boutique': 'Librairie - boutique - Sortie',
      'enceintebasse.0.sortie': 'Librairie - boutique - Sortie',
      'enceintebasse.0.toilettes': 'Toilettes',
      'courchateau.0.ouest': 'Cour du château',
      'donjon.0.cabinetchasses': 'Cabinet des chasses',
      'donjon.1.escaliers': 'Sortie escalier 1er étage',
      'donjon.1.cafemarechaldesaxe': 'Salle Ouest',
      'donjon.1.chambredeslauriers': 'Chambre des lauriers',
      'donjon.1.cabinetdetravailsudouest': 'Cabinet de travail',
      'donjon.1.chambredeconti': "Chambre d'invités",
      'donjon.1.theatredemoliere': 'Ancien théâtre de Molière',
      'donjon.1.chambrecharlesquint': 'Musée du comte de Chambord - 1',
      'donjon.1.museecomtedechambord2': 'Musée du comte de Chambord - 2',
      'donjon.1.museecomtedechambord3': 'Musée du comte de Chambord - 3',
      'donjon.1.museecomtedechambord4': 'Musée du comte de Chambord - 4',
      'donjon.1.museecomtedechambord5': 'Musée du comte de Chambord - 5',
      'donjon.1.loggiaest': 'Loggia Nord - 1er étage',
      'donjon.1.salleest': 'Salle Est',
      'donjon.1.chambredeparade': 'Chambre de parade',
      'donjon.1.salondecompagnie': 'Salon de compagnie',
      'donjon.1.premiereantichambre': 'Première antichambre',
      'donjon.1.loggiaouest': 'Loggia Ouest',
      'donjon.1.chambredelareine': 'Chambre de la reine',
      'donjon.1.antichambredelareine': 'Antichambre de la reine',
      'aileroyale.1.galerieroyale': "Galerie de l'aile royale",
      'aileroyale.1.oratoire': 'Oratoire de François Ier',
      'aileroyale.1.garderobe': 'Garde-robe de François Ier',
      'aileroyale.1.chambreduroi': 'Chambre de François Ier',
      'aileroyale.1.cabinetdetravailduroi': 'Cabinet de travail de François Ier',
      'aileroyale.1.salleduconseil': 'Salle du roi',
      'aileroyale.1.galeriemarignan': 'Galerie Marignan',
      'ailechapelle.1.galeriechapelle': 'Galerie de la chapelle',
      'ailechapelle.1.chapelle': 'Chapelle',
      'donjon.1.antichambreconti': 'Antichambre',
      'donjon.1.chambredumarechaldesaxe': 'Chambre privée',
      'donjon.1.cabinetdesserte': 'Cabinet',
      'donjon.1.cabinetgouverneur': 'Cabinet',
      'donjon.1.chambredugouverneur': 'Chambre du gouverneur',
      'donjon.1.museecomtedechambord6': 'Musée du comte de Chambord - 6',
      'donjon.2.theatredesaxe': 'Ancien théâtre du Maréchal de Saxe',
      'donjon.2.sallevouteeouest': 'Salle voûtée - Ouest',
      'donjon.2.sallevouteeest': 'Salle voûtée - Est',
      'donjon.2.sallevouteesud': 'Salle voutée - Sud',
      'donjon.2.salledexposition6': "Salle d'exposition - 6",
      'donjon.2.salledexposition7': "Salle d'exposition - 7",
      'donjon.2.salledexposition8': "Salle d'exposition - 8",
      'donjon.2.salledexposition9': "Salle d'exposition - 9",
      'donjon.2.salledexposition10': "Salle d'exposition - 10",
      'donjon.2.loggiaest': 'Loggia Est - 2e étage',
      'donjon.2.salledexposition1': "Salle d'exposition - 1",
      'donjon.2.salledexposition2': "Salle d'exposition - 2",
      'donjon.2.salledexposition3': "Salle d'exposition - 3",
      'donjon.2.salledexposition4': "Salle d'exposition - 4",
      'donjon.2.salledexposition5': "Salle d'exposition - 5",
      'ailechapelle.2.galeriedestrophees': 'Galerie des trophées',
      'donjon.3.escaliernord': 'Sortie escalier Nord',
      'donjon.3.escaliersud': 'Sortie escalier Sud',
      'donjon.3.terrassesud': 'Terrasse Sud',
      'donjon.3.terrasseest': 'Terrasse Est',
      'donjon.3.terrassenord': 'Terrasse Nord',
      'donjon.3.terrasseouest': 'Terrasse Ouest',
    },
    'france.paris.conciergerie': {
      'accueil.0': 'Accueil et billetterie',
      'sallegensdarmesest.0': "La salle des Gens d'armes - Est",
      'cuisines.0': 'Les cuisines',
      'salledesgardes.0': 'Salle des gardes',
      'sallegensdarmesouest.0': "La salle des Gens d'armes - Ouest",
      'grandesalleouestsallegensdarmesouest.0': "Grand'Salle - Ouest",
      'parlementsalledesgardes.0': 'Parlement de Paris',
      'boutique.0': 'Boutique',
      'cellulemarieantoinette.0': 'Cellule de Marie-Antoinette',
      'couloirdesprisonniers.0': 'Le couloir des prisonniers',
      'salleexposition.0': 'La Révolution',
      'chapelledesgirondins.0': 'Chapelle',
      'courdesfemmes.0': 'Cour des femmes',
      'toilets.0': 'Toilettes',
      'alarm.0': 'Alarme',
      'salledescondamnes.1': 'Salle des Noms',
      'couloirdesprisonniersentresol.1': 'Le couloir des prisonniers - 1er étage',
      'museeprison.1': 'La Révolution et la justice',
    },
    'france.avignon.palais-des-papes': {
      'grandetresoreriehaute.-1': 'Grande Trésorerie Haute',
      'grandetresoreriebasse.-1': 'Grande Trésorerie Basse',
      'tresorbas.-1': 'Trésor Bas',
      'jardins.-1': 'Jardins',
      'accueil.0': 'Accueil - Petite Audience',
      'courhonneurouest.0': "Cour d'Honneur",
      'courhonneurest.0': "Cour d'Honneur",
      'courhonneurramp.0': "Cour d'Honneur",
      'courcloitre.0': 'Cour du Palais Vieux',
      'consistoire.0': 'Consistoire',
      'sallejesus.0': 'Salle de Jésus',
      'revestiaire.0': 'Revestiaire',
      'chambrecamerier.0': 'Chambre antique du Camérier',
      'escalierhonneurground.0': "Escalier d'Honneur",
      'grandeaudienceest.0': 'Grande Audience - Est',
      'grandeaudienceouest.0': 'Grande Audience - Ouest',
      'livredor.0': 'Accueil - Petite Audience',
      'courpalaisvieux.1': 'Galerie supérieure Est',
      'grandtinelnord.1': 'Grand Tinel - Nord',
      'grandtinelsud.1': 'Grand Tinel - Sud',
      'cuisinehaute.1': 'Cuisine Haute',
      'chambreparement.1': 'Chambre de Parement',
      'chambrepape.1': 'Chambre du Pape',
      'chambrecerf.1': 'Chambre du Cerf',
      'sacristienord.1': 'Sacristie Nord',
      'grandechapelleest.1': 'Grande Chapelle Est',
      'revestiairecardinaux.1': 'Revestiaire des Cardinaux',
      'grandechapelleouest.1': 'Grande Chapelle Ouest',
      'chambreneuvecamerier.1': 'Chambre neuve du Camérier',
      'escaliertourgache.1': 'Tour de la Gâche',
      'chambrenotaires.1': 'Chambre des Notaires',
      'loggia.1': 'Loggia - fenêtre des Indulgences',
      'escalierhonneur1stf.1': "Escalier d'Honneur",
      'coursivegrandsdignitaires.2': 'Coursive des Grands Dignitaires',
      'cafegrandsdignitaires.2': 'Café des Grands Dignitaires',
      'terrassegrandsdignitaires.2': 'Terrasse des Grands Dignitaires',
      'toilettesgrandeaudience.0': 'Toilettes Grande Audience',
      'salleartillerie.0': 'Alarme',
    },
    'france.sainte-mere-eglise.airborne-museum': {
      'accueil.0.caisse': 'Accueil, billetterie',
      'parc.0.sherman': 'Parc',
      'waco.0.droite': 'Bâtiment Waco, planeur',
      'waco.0.gauche': 'Bâtiment Waco, passerelle',
      'parc.0.truck': 'Parc',
      'c47.0': 'Bâtiment C-47',
      'c47.0.gauche': 'Bâtiment C-47 – Entrée',
      'c47.0.droite': 'Bâtiment C-47 - Sortie',
      'c47.0.videoroom': 'Bâtiment C-47, salle vidéo',
      'c47.briefingroom': 'Salle de briefing, Angleterre',
      'toilettes.0': 'Toilettes',
      'accueil.0.boutique': 'Boutique',
      'accueil.0.sortie': 'Sortie',
      'parc.0.entreeneptune': 'Parc',
      'reagan.0': 'Bâtiment Reagan',
      'neptune.0.sortie': 'Passerelle vers le bâtiment Reagan',
      'neptune.0.para': 'Bâtiment Opération Neptune, entrée',
      'neptune.0.sasstemere': "Sainte-Mère-Église : l'attaque",
      'neptune.0.sme': 'Sainte-Mère-Église : D-Day',
      'neptune.0.lafiere': 'La bataille de la Fière',
      'neptune.0.merderet': 'La bataille de la Fière (2ème partie)',
      'neptune.0.haies': 'La bataille des haies',
      'neptune.0.toilettes': 'Toilettes',
      'neptune.0.ambulance': 'Bâtiment Opération Neptune, hall',
      'neptune.0.livredor': "Livre d'or",
      'c47.1.passerelle': 'Bâtiment C-47, passerelle',
      'c47.1.top': 'Bâtiment C-47, belvédère',
    },
    'france.blois.chateau': {
      'accueil.0': 'Entrée',
      'toilettes.0': 'Toilettes',
      'boutique.0': 'Boutique',
      'chapelle.0': 'Chapelle Saint-Calais',
      'cour.0.nord': "Cour d'honneur nord",
      'cour.0.sud': "Cour d'honneur sud",
      'cour.0.est': "Cour d'honneur est",
      'cour.0.ouest': "Cour d'honneur ouest",
      'accesfournisseur.0': 'Accès fournisseur',
      'escaliersarchitecture.0': "Escalier vers les salles d'architecture",
      'escalierhonneur.0': "Escalier d'honneur Gaston d'Orléans",
      'guichet.0': 'Guichet',
      'jardins.0': 'Bastion de Marie de Médicis',
      'terrassefoix.0': 'Terrasse de la Tour du Foix',
      'cour.0.livredor': "Livre d'or",
      'architecture1.0': "Salle d'architecture n°1",
      'architecture2.0': "Salle d'architecture n°2",
      'architecture3.0': "Salle d'architecture n°3",
      'architecture4.0': "Salle d'architecture n°4",
      'etatsgeneraux.0': 'Salle des États Généraux',
      'interpretation1.0': "Salle d'interprétation 1",
      'interpretation2.0': "Salle d'interprétation 2",
      'interpretation3.0': "Salle d'interprétation 3",
      'tourdumilieu.0': 'Tour du Milieu',
      'chambrereine.1': 'Chambre de la reine',
      'gastonexpo1.1': 'Salle exposition 1',
      'gastonexpo2.1': 'Salle exposition 2',
      'gastonexpo3.1': 'Salle exposition 3',
      'galeriereine.1': 'Galerie de la reine',
      'galeriepaysage.1': 'Galerie des paysages',
      'galerietapisserie.1': 'Galerie des tapisseries',
      'garderobe.1': 'Garde-robe',
      'oratoire.1': 'Oratoire',
      'salleblois.1': 'Salle de Blois',
      'salleviergeenfant.1': "Salle des Vierges à l'Enfant",
      'sallechateaux.1': 'Salle des Châteaux',
      'sallehistoires.1': 'Salle des histoires',
      'sallepetitsformats.1': 'Salle des petits formats',
      'salleportraits.1': 'Salle des portraits',
      'sallesalons.1': 'Salle des salons',
      'sallevalois.1': 'Salle des Valois',
      'salleroi.1': 'Salle du roi',
      'studiolo.1': 'Studiolo',
      'galeriebelvedere.2': 'Galerie du belvédère des jardins',
      'cabinetetiquette.2': "Cabinet de l'étiquette",
      'cabinetguerrereligions.2': 'Cabinet des guerres de Religion',
      'cabinetneuf.2': 'Cabinet neuf',
      'chambreroi.2': 'Chambre du roi',
      'galerieduban.2': 'Galerie Duban',
      'salleconseil.2': 'Salle du Conseil',
      'salleneorenaissance.2': 'Salle néo-renaissance',
    },
    'france.la-mongie.pic-du-midi': {
      'chambres-1': 'Chambres',
      'accueil.0': 'Accueil',
      'galeriepanorama.0': 'Galerie Panorama',
      'terrasse.0': 'Terrasse du Pic du Midi',
      'maquette.0': 'Salle de la Maquette',
      'experiences.1': 'Espace Expériences',
      'cieletoile.1': 'Réserve ciel étoilé',
      'merveilles.2': 'Galerie des Merveilles',
      'planetarium.2': 'Planetarium',
      'bistrot.0': 'Bistrot',
      'restaurant.-1': 'Restaurant',
      'sortienord.0': 'Sortie nord',
      'sortiesud.0': 'Sortie sud',
    },
    'france.loches.donjon': {
      'accueil.0': "Salle d'Accueil",
      'palier.0': 'Palier',
      'cachotbalue.-1': 'Cachot du Cardinal Balue',
      'excentriques.1': 'Cachot des Excentriques',
      'sallegardes.1': 'Salle des gardes',
      'celluleduc.2': "Cellule du duc d'Alençon",
      'rebelles.2': 'Cachot des rebelles',
      'courdonjon.0': 'Cour du donjon',
      'sallesforza.-1': 'Salle Sforzesca',
      'cachotsforza.-2': 'Cachot de Ludovico Sforza',
      'cachoteveques.-3': 'Cachot des évêques',
      'carriere.-4': 'Carrière',
      'courchateauwest.0': 'Cour du château (ouest)',
      'courchateaueast.0': 'Cour du château (est)',
      'tourabec.0': 'Tour à bec',
      'jardinmedieval.0': 'Jardin médiéval',
      'cellier.0': 'Cellier',
      'grandesalle.1': 'Grande salle',
      'chambrecomptale.2': 'Chambre comtale',
      'chapelle.2': 'Chapelle',
      'niveaudefensif.3': 'Niveau défensif',
      'tourporte.0': 'Tour porte',
      'tourporte.1': 'Tour porte',
      'donjon.0': 'Escalier du donjon',
      'tourneuve.0': 'Salle Un lieu une histoire',
      'terrasse.3': 'Terrasse',
      'toilets.0': 'Toilettes',
    },
    'france.amboise.chateau': {
      'accueil.-1': 'Accueil et billetterie',
      'rampe.-1': "Rampe d'accès au chateau",
      'rampeorangerie.-1': 'Ramp access to the castle',
      'alleessw.1': 'Jardin : les allées (sud-ouest)',
      'alleesse.1': 'Jardin : les allées (sud-est)',
      'alleesne.1': 'Jardin : les allées (nord-est)',
      'alleesnw.1': 'Buste de Léonard de Vinci',
      'alleessudouest.1': 'Jardin : les allées (sud-ouest)',
      'alleessudest.1': 'Jardin : les allées (sud-est)',
      'alleesnordest.1': 'Jardin : les allées (nord-est)',
      'alleesnordouest.1': 'Buste de Léonard de Vinci',
      'cabinetorleans.2': 'Cabinet Orléans-Penthièvre',
      'chambreorleans.2': 'Chambre Orléans',
      'chambreroi.1': 'Chambre du roi',
      'chapelle.0': 'Chapelle Saint-Hubert',
      'aumale.1': "Galerie d'Aumale",
      'garderobe.1': 'Garde-robe',
      'grandechambre.1': 'Grande chambre',
      'grandesalle.1': 'Grande salle',
      'naplesouest.1': 'Jardin de Naples (ouest)',
      'naplesest.1': 'Jardin de Naples (est)',
      'jardinorient.1': "Jardin d'Orient",
      'orangerie.-1': 'Orangerie : café et toilettes',
      'promenoir.0': 'Promenoir des gardes',
      'minimes.1': 'Rampe cavalière',
      'sallegardes.0': 'Salle des gardes',
      'pilier.0': 'Salle du pilier',
      'tambourineurs.1': 'Salle des Tambourineurs',
      'jardinmidi.1': 'Jardin du midi',
      'portelions.1': 'Porte des Lions',
      'salonmusique.2': 'Salon de musique',
      'minimes.2': 'Toit de la tour des Minimes',
      'terrassesnord.0': 'Terrasses (nord)',
      'terrassessud.0': 'Terrasses (sud)',
      'terrassesup.1': 'Terrasse supérieure',
      'tourheurtault.-1': 'Tour Heurtault',
      'courheurtault.-1': 'Cour Heurtault',
      'boutique.-1': 'Boutique',
    },
    'france.chinon.forteresse': {
      'accueil.0.accueil': 'Accueil, billetterie, boutique',
      'acceschateau.0': 'Accès au château',
      'accueil.0.toilettes': 'Toilettes',
      'alarm.0.rampe': 'Alarme rampe',
      'alarm.0.parking': 'Alarme parking',
      'rampeacces.0': 'Accès au château (rampe)',
      'argenton.-3': "Tour d'Argenton, niv. -3",
      'argenton.-2': "Tour d'Argenton, niv. -2",
      'argenton.-1': "Tour d'Argenton, niv. -1",
      'argenton.0': "Tour d'Argenton, terrasse",
      'chiens.-2': 'Tour des Chiens, niv. -2',
      'chiens.-1': 'Tour des Chiens, niv. -1',
      'chiens.0': 'Tour des Chiens, niv. 0',
      'chiens.1': 'Tour des Chiens, terrasse',
      'boissy.-1': 'Tour de Boissy, niv. -1',
      'boissy.0': 'Tour de Boissy, niv. 0',
      'horloge.0': "Tour de l'Horloge, niv. 0",
      'horloge.1': "Tour de l'Horloge, niv. 1",
      'horloge.2': "Tour de l'Horloge, niv. 2",
      'horloge.3': "Tour de l'Horloge, niv. 3",
      'horloge.4': "Tour de l'Horloge, niv. 4",
      'horloge.5': "Tour de l'Horloge, chemin de ronde",
      'coudray.-1': 'Tour du Coudray, niv. -1',
      'coudray.0': 'Tour du Coudray, niv. 0',
      'coudray.1': 'Tour du Coudray, niv. 1',
      'coudray.2': 'Tour du Coudray, niv. 2',
      'moulin.0': 'Tour du Moulin, niv. 0',
      'fortdumilieu.0.toilettes': 'Toilettes',
      'forteresse.0.aula': 'Salle Plantagenêt',
      'forteresse.0.archeo': 'Salle Histoire et Archéologie',
      'forteresse.0.dependances': 'Cuisines, salle 2',
      'forteresse.0.cuisine': 'Cuisines, salle 1',
      'fortdumilieu.0.bombarde': 'Parc de la Forteresse (bombarde)',
      'fortdumilieu.0.sallereco': 'Parc de la Forteresse (salle reco)',
      'fortdumilieu.0.chapellesud': 'Parc de la Forteresse (chapelle sud)',
      'fortdumilieu.0.chapellenord': 'Parc de la Forteresse (chapelle nord)',
      'fortdumilieu.0.cafe': 'Point gourmand (salon de thé)',
      'fortducoudray.0.courtourcoudray': 'Cour du fort du Coudray',
      'fortducoudray.0': 'Fort du Coudray',
      'forteresse.1.marieanjou': "Salle des estampes Jeanne d'Arc",
      'forteresse.1.jeannedarc': "Salle des collections Jeanne d'Arc",
      'forteresse.1.parement': 'Chambre de parement de Charles VII',
      'forteresse.1.charlesvii': 'Chambre de retrait de Charles VII',
      'accueil.2.terrasse': 'Terrasse du Fort Saint-Georges',
    },
    'france.gordes.senanque': {
      'accueil.1': 'Accueil/Billetterie',
      'boutique.0': "Boutique de l'Abbaye",
      'maquette.1': 'Salle des maquettes',
      'dortoir.1': 'Dortoir',
      'abbatiale.0': 'Église abbatiale',
      'cloitre.0': 'Cloître',
      'chauffoir.0': 'Chauffoir',
      'chapitre.0': 'Salle du Chapitre',
      'refectoire.0': 'Chapelle/Réfectoire',
      'toilets.0': 'Toilettes',
      'alarme.0': 'Alarme',
      'entree.0': 'Entrée',
      'retourhistopad.0': 'Retours HistoPad',
    },
    'france.paris.pcv': {
      alma: "Place de l'alma",
      arcdetriomphe: "L'Arc de Triomphe",
      assembleenationale: "L'Assemblée nationale",
      avenueopera: "L'avenue de l'Opéra",
      beauxarts: "L'École nationale supérieure des beaux-arts",
      bouquiniste: 'Les bouquinistes',
      champselysees1: "L'Avenue des Champs-Elysées",
      champselysees2: 'Les Champs-Élysées',
      comediefrancaise: 'La Comédie-Française',
      conciergerie: 'La Conciergerie',
      concorde: 'La place de la Concorde',
      hdv: "L'Hôtel de Ville",
      immeublehaussmanien: 'Un immeuble haussmannien',
      institutdefrance: "L'Institut de France",
      invalides: 'Le dôme des Invalides',
      kiosquepcv: 'Nos offres',
      kiosquepcvtuileries: 'Nos offres - Tuileries',
      lido: 'Le Lido de Paris',
      louvre: 'Le Louvre après Louis XIV',
      louvremedieval: 'La forteresse du Louvre',
      louvretoday: 'Le musée du Louvre',
      luxembourg: 'Le jardin du Luxembourg',
      museebranly: 'Le musée du Quai Branly - Jacques-Chirac',
      notredame: 'Notre-Dame de Paris',
      opera: "L'opéra Garnier",
      orsay: "Le musée d'Orsay",
      palaistokyo: 'Le palais de Tokyo',
      pantheon: 'Le Panthéon',
      pcvstart: 'PCV start',
      placevendome: 'La place Vendôme',
      quartierelysee: "Le quartier de l'Élysée",
      saintgermaindespres: 'Saint-Germain-des-Prés',
      saintsulpice: "L'église Saint-Sulpice",
      sorbonne: "L'université de la Sorbonne",
      stopbateaux: 'Arrêt croisière et tour Eiffel',
      toureiffel: 'Vue de la tour Eiffel',
      trocadero: 'Le Trocadéro',
      tuileries: 'Le jardin des Tuileries',
      tutorials: 'Tutoriel',
      pcvend: 'PCV end',
    },
    'france.arcetsenans.saline': {
      'accueil.0': 'Billetterie',
      'exterieuraccueil.0': 'Cour ',
      'hallmaisondirecteur.0': 'Vestibule',
      'museeselsalle1.0': 'Musée du Sel - Salle 1',
      'museeselsalle2.0': 'Musée du Sel - Salle 2',
      'museeselsalle3.0': 'Musée du Sel - Salle 3',
      'museeselsalle4.0': 'Vestibule',
      'museeselsalle5.0': 'Musée du Sel - Salle 5',
      'museeselsalle6.0': 'Musée du Sel - Salle 6',
      'berneouest.0': 'Berne Ouest',
      'tonnellerieentree.0': 'Auditorium ',
      'tonnelleriemusee.0': 'Musée Ledoux - Oeuvre bâtie',
      'tonnelleriemusee.galerieledoux.0': 'Musée Ledoux - Oeuvre bâtie',
      'tonnelleriemusee.filmguimard.0': 'Musée Ledoux - Oeuvre bâtie',
      'tonnelleriemusee.filmbesancon.0': 'Musée Ledoux - Oeuvre bâtie',
      'tonnelleriemusee.filmsaline.0': 'Musée Ledoux - Oeuvre bâtie',
      'tonnelleriemusee.filmthelusson.0': 'Musée Ledoux - Oeuvre bâtie',
      'tonnelleriemusee.galerieprojets.0': 'Musée Ledoux - Projets',
      'bernierest.0': 'Berniers Est ',
      'bernierest.cuisine.0': 'Berniers Est ',
      'bernierest.jardins.0': 'Les jardins',
      'exterieurmuseesel.0': 'Cour ',
      'exterieurnord.0': 'Cour ',
      'exterieurouest.0': 'Cour ',
      'exterieursudouest.0': 'Cour ',
      'exterieursudest.0': 'Cour ',
      'exterieurest.0': 'Cour ',
      'paliermaisondirecteur.1': 'Palier du 1er étage ',
      'tonnellerieetage.1': 'Musée Ledoux - Propylées de Paris',
      'toilettesberneest.0': 'Toilettes Berne Est',
      'boutique.0': 'Boutique',
      'alarm.0': 'Alarme',
    },
    'deutschland.meissen.albrechtsburg': {
      'basementhall.-1': 'Cave centrale',
      'sludgecellarvestibule.-1': 'Antichambre de la salle de filtrage',
      'staircase.-1': "Cage d'escalier",
      'reception.0': 'Accueil, boutique, café',
      'cloakroom.0': 'Vestiaire',
      'specialexhibitionarea.0': "Salles d'exposition temporaire",
      'littlespiralstaircase.0': 'Petit escalier',
      'largehall.1': 'Grande salle',
      'largecourthall.1': "Salle d'apparat",
      'smalldiningroom.1': 'Petite salle à manger',
      'firstelectorsroom.1': 'Premier salon du prince-électeur',
      'secondelectorsroom.1': 'Second salon du prince-électeur',
      'chapel.1': 'Chapelle',
      'smallroom.1': 'Petite salle',
      'littlespiralstaircase.1': 'Petit escalier',
      'largespiralstaircase.1': 'Grand escalier',
      'largestaircaseantechamber.2': 'Antichambre du grand escalier',
      'bottgerroom.2': 'Salle Böttger',
      'smallappellationroom.2': 'Petite cour de justice',
      'largeappellationroom.2': 'Grande cour de justice',
      'electoraugustsroom.2': 'Salle du prince-électeur Auguste',
      'heraldichall.2': 'Salle des armoiries',
      'spiralstaircaseroom.2': 'Salon du grand escalier',
      'largeappellationroomchamber.2': 'Chambre de la grande cour de justice',
      'oldduchesschamber.2': "Chambre de l'ancienne duchesse",
      'spiralstaircasechamber.2': 'Chambre du grand escalier',
      'chapel.2': 'Cabinet de la tour de la chapelle',
      'ladieschamber.2': 'Chambre des dames',
      'smallspiralstaircaseantechamber.2': 'Antichambre du petit escalier',
      'littlespiralstaircase.2': 'Petit escalier',
      'largespiralstaircase.2': 'Grand escalier',
      'ladiesroom1.3': 'Appartement des femmes, salle 1',
      'chamberbytheladiesrooms.3': "Chambre à côté de l'appartement des femmes",
      'ladiesroom2.3': 'Appartement des femmes, salle 2',
      'ladiesroom3.3': 'Appartement des femmes, salle 3',
      'ladiesroom4.3': 'Appartement des femmes, salle 4',
      'chamberinfrontofladiesrooms.3': "Chambre face à l'appartement des femmes",
      'menschamber.3': 'Chambre des messieurs',
      'chapel.3': 'Cabinet du rossignol',
      'largestaircaseantechamber.3': 'Antichambre du grand escalier',
      'spiralstaircaseroom.3': 'Salon du grand escalier',
      'spiralstaircasechamber.3': 'Chambre du grand escalier',
      'councilchamber.3': 'Salle du conseil',
      'chambertocouncilroom.3': 'Chambre de la salle du conseil',
      'littlespiralstaircase.3': 'Petit escalier',
      'largespiralstaircase.3': 'Grand escalier',
      'toilets.-1': 'Toilettes',
    },
    'deutschland.moritzburg.schlossmoritzburg': {
      'entrancehall.0': "Hall d'entrée",
      'anteroomtofeatherroom.0': 'Antichambre de la chambre de plumes',
      'exhibitionroom.0': "Salles d'exposition",
      'featherroom.0': 'Chambre de plumes',
      'entrancehall.0.timegate1945': "Hall d'entrée",
      'entrancehall.0.timegateguestbook': "Hall d'entrée",
      'toilets.0': 'Toilettes',
      'shop.0': 'Magasin',
      'restaurant.0': 'Restaurant',
      'reception.0': 'Réception',
      'stonehall.1': 'Hall de pierre',
      'stonehall.1.timegateselfie': 'Hall de pierre',
      'monstroushall.1': 'Salle des Monstruosités',
      'palacechapel.1': 'Chapelle',
      'dininghall.1': 'Salle des festins',
      'billiardhall.1': 'Salle de Billard',
      'furnitureroom.1': 'Appartement des membres de la famille royale, salle 2',
      'augustroom1.1': 'Appartement du roi Auguste le Fort, salle 1',
      'augustroom2.1': 'Appartement du roi Auguste le Fort, salle 2',
      'ladiesportraitsroom.1': 'Appartement de la princesse-électrice Marie-Josèphe, salle 3',
      'guestroom2.1': 'Appartement de la princesse-électrice Marie-Josèphe, salle 1',
      'electorroom1.1': 'Appartement du prince-électeur Frédéric Auguste, salle 1',
      'electorroom2.1': 'Appartement du prince-électeur Frédéric Auguste, salle 2',
      'bruhlroom.1': 'Appartement du prince-électeur Frédéric Auguste, salle 3',
    },
    'germany.colditz.schloss-colditz': {
      'guardhouse.0.welcomearea': 'Accueil',
      'chapel.0': 'Aile de la chapelle',
      'electorshouse.0.displaydepot': "Rez-de-chaussée de l'aile des Electeurs",
      'electorshouse.0.silverchamber': "Chambre d'argent",
      'courtyard.0': 'Cour arrière du château',
      'guardhouse.1.chamber': 'La salle des gardes',
      'cellar.1.banquetroom': 'Salle des banquets',
      'cellar.1.anteroom': 'Vestibule',
      'cellar.1.huntingroom': 'Salle de chasse',
      'cellar.1.storeroom': 'Parloir inférieur',
      'chapel.1.gallery': 'Tribune de la chapelle',
      'chapel.2.bath': "Musée de l'évasion I",
      'chapel.3.womanapartments': "Musée de l'évasion II",
      'chapel.4.gliderloft': "Musée de l'évasion III",
    },
  },
}
